export const cpfMask = [
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
];

export const cnpjMask = [
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    '.',
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    '.',
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    '/',
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    /[A-Z0-9]/i,
    '-',
    /\d/,
    /\d/,
];

export const phoneMask = [
    '(',
    /[1-9]/,
    /[1-9]/,
    ')',
    ' ',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '-',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
];

export const cellPhoneMask = [
    '(',
    /[1-9]/,
    /[1-9]/,
    ')',
    ' ',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '-',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
];

export const cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

export const dateMask = [
    /[0,1,2,3]/,
    /[0-9]/,
    '/',
    /[0,1]/,
    /[0-9]/,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];

export const phoneAndCellPhoneMask = (value) => {
    if (value && value.length >= 15) {
        return cellPhoneMask;
    }
    return phoneMask;
};

export const creditCardMask = [
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '.',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '.',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    '.',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
];
